var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMarkFullColor = function SvgMarkFullColor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 228,
    viewBox: "0 0 231 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.81 105.984C227.046 101.657 185.256 0 153.139 0V4.2162C176.672 4.2162 210.912 74.1142 223.712 104.661H209.217C203.926 91.9711 164.616 0 134.069 0V4.2162C157.617 4.2162 191.842 74.1004 204.642 104.661H190.134C184.857 91.9711 145.561 0 115 0V4.2162C138.547 4.2162 172.773 74.1004 185.573 104.661H171.064C165.801 91.9711 126.491 0 95.9306 0V4.2162C119.478 4.2162 153.704 74.1004 166.504 104.661H151.995C146.718 91.9435 107.408 0 76.875 0V4.2162C101.194 4.2162 136.935 78.8264 148.647 107.568L149.184 108.877H230.009L228.824 105.97L228.81 105.984Z",
    fill: "url(#paint0_linear_443_5065)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8699 0C44.7386 0 2.94859 101.657 1.18495 105.984L0 108.891H80.8243L81.3617 107.582C93.0734 78.8264 128.801 4.2162 153.134 4.2162V0H76.8699ZM121.912 4.2162C93.9552 22.39 63.5324 93.5969 58.9304 104.661H44.4217C57.2219 74.1142 91.4613 4.2162 114.995 4.2162H121.912ZM102.842 4.2162C74.8858 22.39 44.463 93.5969 39.861 104.661H25.3523C38.1525 74.1142 72.3781 4.2162 95.9255 4.2162H102.842V4.2162ZM76.8699 4.2162H83.7867C55.8165 22.39 25.3937 93.5969 20.7917 104.661H6.29675C19.0831 74.1142 53.3226 4.2162 76.8699 4.2162V4.2162ZM77.9997 104.661H63.5048C76.2912 74.1142 110.517 4.2162 134.064 4.2162H140.981C113.025 22.39 82.6017 93.5832 77.9997 104.661V104.661Z",
    fill: "url(#paint1_linear_443_5065)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.134 227.776V223.559C128.801 223.559 93.0734 148.949 81.3479 120.207L80.8106 118.898H0L1.18495 121.806C2.94859 126.132 44.7386 227.789 76.8699 227.789V223.573C53.3226 223.573 19.0969 153.675 6.29675 123.128H20.8054C26.0826 135.832 65.3787 227.789 95.9393 227.789V223.573C72.3919 223.573 38.1663 153.689 25.3661 123.128H39.8748C45.1519 135.832 84.4618 227.789 115.009 227.789V223.573C91.4751 223.573 57.2356 153.689 44.4355 123.128H58.9442C64.2213 135.832 103.531 227.789 134.078 227.789V223.573C110.544 223.573 76.305 153.689 63.5048 123.128H77.9997C83.2907 135.846 122.587 227.789 153.134 227.789V227.776Z",
    fill: "url(#paint2_linear_443_5065)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.184 118.898L148.647 120.207C136.921 148.948 101.194 223.559 76.875 223.559V227.775H153.139C185.256 227.775 227.06 126.117 228.81 121.791L229.995 118.884H149.17L149.184 118.898ZM89.0276 223.559C116.984 205.385 147.393 134.192 152.009 123.114H166.518C153.717 153.674 119.492 223.559 95.9444 223.559H89.0414H89.0276ZM108.083 223.559C136.053 205.385 166.476 134.178 171.064 123.114H185.573C172.773 153.674 138.547 223.559 115 223.559H108.083V223.559ZM127.153 223.559C155.123 205.385 185.532 134.178 190.134 123.114H204.642C191.842 153.674 157.617 223.559 134.069 223.559H127.153V223.559ZM153.139 223.559H146.222C174.192 205.385 204.601 134.178 209.203 123.114H223.698C210.898 153.661 176.672 223.559 153.125 223.559H153.139Z",
    fill: "url(#paint3_linear_443_5065)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_443_5065",
    x1: 153.006,
    y1: 1.35401,
    x2: 229.692,
    y2: 109.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65F1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CEF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_443_5065",
    x1: 151.728,
    y1: -1.90143,
    x2: 0.688939,
    y2: 109.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65F1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F286"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_443_5065",
    x1: 98.8426,
    y1: 228.15,
    x2: 15.3767,
    y2: 105.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65F1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F187"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_443_5065",
    x1: 85.7759,
    y1: 237.461,
    x2: 222.913,
    y2: 111.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65F1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CEF8"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMarkFullColor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "mark-full-color.5ead4bf990760a92e8b2f5984899f0bd.svg";